const PAGES = {
  privacy: {
    title: "Privacy & Data Protection",
    updated: "August 2026",
    sections: [
      {
        h: "What we collect",
        body: "When you use the contact form or join the registry, we collect the details you provide: your name, organisation or role, email address, region and message. We do not collect sensitive personal data through this website.",
      },
      {
        h: "How we use it",
        body: "Your information is used only to respond to your enquiry or to register your interest in CYRA Krida verification as it becomes available in your region. We do not sell or share your information with third parties for marketing.",
      },
      {
        h: "How it is handled",
        body: "Workforce and contact data is stored securely and access is restricted to authorised members of the Krida team. Verification, credential and identity information handled by the Krida platform is subject to role-based access and user consent.",
      },
      {
        h: "Your control",
        body: "You may request access to, correction of, or deletion of your information at any time by writing to hello@krida.me. We retain submissions only as long as needed for the purpose they were provided.",
      },
      {
        h: "Safeguards",
        body: "Where information relates to minors involved in sporting programmes, additional consent and handling safeguards apply through the registering organisation.",
      },
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "August 2026",
    sections: [
      {
        h: "The website",
        body: "This website describes CYRA Krida — The Sports Workforce OS. Content is provided for general information and does not constitute a binding offer of services.",
      },
      {
        h: "Acceptable use",
        body: "You agree to provide accurate information when submitting forms and not to misuse the website or attempt unauthorised access to any part of it.",
      },
      {
        h: "Product information",
        body: "Some interface visuals on this site are representative illustrations of the Krida platform and are marked as such. Availability of specific capabilities may vary by engagement and region.",
      },
      {
        h: "Contact",
        body: "For questions about these terms, write to hello@krida.me. CYRA Krida operates from Singapore, Malaysia and India.",
      },
    ],
  },
};

export default function LegalPage({ page }) {
  const P = PAGES[page];
  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${page}`}>
      <header className="border-b border-kn-navy/10">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-6">
          <a href="/" className="flex items-center gap-3" data-testid="legal-home-link">
            <img src="/logo-dark-wm.png" alt="CYRA" className="h-7 w-auto" />
            <span className="h-5 w-px bg-kn-navy/15" />
            <span className="font-serif text-lg italic leading-none text-kn-blue">Krida</span>
          </a>
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-kn-navy/40">The Sports Workforce OS</span>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-4xl font-semibold tracking-tight text-kn-navy">{P.title}</h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-kn-navy/40">Last updated · {P.updated}</p>
        <div className="mt-12 space-y-10">
          {P.sections.map((s) => (
            <div key={s.h}>
              <h2 className="text-lg font-semibold text-kn-navy">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-kn-navy/65">{s.body}</p>
            </div>
          ))}
        </div>
        <a href="/" className="mt-16 inline-flex items-center gap-2 text-sm font-semibold text-kn-blue" data-testid="legal-back-link">
          ← Back to krida.me
        </a>
      </main>
    </div>
  );
}
